module.exports = __webpack_public_path__ + "/login_ui/img/cu-60dc993bc935939446ac98c8da0aac28.svg";